// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#deck {
  overscroll-behavior-y: contain;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
  position: fixed;
  overflow: hidden;
  background-color: var(--background);
}

#deck > .animated {
  position: absolute;
  width: 100vw;
  height: 65vh;
  will-change: transform;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10vh;
  z-index: 2;
}

#deck > .animated > .card {
  box-shadow: var(--theme-consistent) 0px 0px 2px 0px;
  background-size: auto 85%;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius: 10px;
}

#deck .loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#deck .deck-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#deck .load-button {
  background: linear-gradient(135deg, #ff5e5e, #ff9966);
  color: white;
  border-radius: 8px;
  padding: 12px 24px;
  box-shadow: rgba(40, 40, 40, 0.35) 0px 5px 15px;
  border: none;
  cursor: pointer;
  font-size: 1.125rem;
  font-weight: bold;
  transition: all 0.3s ease;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  width: 100%;
  max-width: 400px;
}

#deck .subscription-pitch-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#deck .expand-search {
  width: 90vw;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  color: var(--text-primary);
}

#deck .load-button:active {
  transform: scale(0.95);
  box-shadow: 0px 3px 10px rgba(255, 153, 102, 0.3);
}

#deck .undo-button,
#deck .fetchDetail-button {
  position: absolute;
  top: 17%;
  background: linear-gradient(135deg, #ff5e5e, #ff9966);
  border: none;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  padding: 0 8px;
  border-radius: 4px;
  font-size: 2.25em;
  transition-duration: 0.4s;
  cursor: pointer;
  z-index: 2;
  box-shadow: 0px 5px 20px rgba(255, 153, 102, 0.5);
  width: auto;  /* Override any inherited width */
  max-width: none;  /* Override any inherited max-width */
  min-height: auto;  /* Override any inherited min-height */
}

#deck .undo-button {
  left: 21vw;
}

#deck .fetchDetail-button {
  right: 21vw;
}

#deck .undo-button:disabled {
  color: #aaa;
  background: linear-gradient(135deg, #ff5e5e5f, #ff996647);
  cursor: not-allowed;
}

#deck .modalSpinner {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  z-index: 2;
}

#deck .fetchingContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

#deck .isFetchingText {
  color: var(--theme-consistent);
  font-size: 1.5rem;
}

#deck .button-container {
  width: 90vw;
  height: calc(100vh - 150px);
  display: flex;
  justify-content: center;
  gap: 12px;
  align-items: center;
  flex-direction: column;
  overflow-y: auto;
  padding: 16px;
  margin-bottom: 4rem;
}

/* Make all direct children follow flex rules */
#deck .button-container > * {
  width: 100%;
  max-width: 400px;
  margin: 0;
}

#deck .undo-button.end-of-deck {
  position: fixed;
  top: auto;
  bottom: 50px;  /* Or wherever looks good with your layout */
  left: 50%;
  transform: translateX(-50%);
  z-index: 999999999999999999999;  /* Ensure it's above other elements */
}

#deck .expand-search p {
  margin-bottom: 12px;
}

/* Style nested p tags in buttons */
#deck .load-button p {
  margin: 0;
}

@media screen and (max-width: 640px) {
  #deck .button-container {
    gap: 8px;
    padding: 12px;
  }

  #deck .load-button {
    font-size: 1rem;
    padding: 10px 20px;
    min-height: 44px;
  }
}

/* For smaller iPhones (iPhone SE, standard iPhone models) */
@media screen and (max-width: 427px) {
  #deck .button-container {
    gap: 8px;
    padding: 12px;
  }

  #deck .load-button {
    font-size: 1rem;
    padding: 10px 20px;
    min-height: 44px;
  }
}

/* For iPhone Max sizes and tablets up to 640px */
@media screen and (min-width: 428px) and (max-width: 640px) {
  #deck .button-container {
    gap: 8px;
    padding: 12px;
  }

  #deck .load-button {
    font-size: 1.4rem;
    padding: 20px 40px;
    min-height: 44px;
  }
}
/* .hide {
  display: none;
} */
`, "",{"version":3,"sources":["webpack://./src/assets/Deck.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;EACzB,4BAA4B;EAC5B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,+CAA+C;EAC/C,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,UAAU;EACV,iDAAiD;EACjD,WAAW,GAAG,iCAAiC;EAC/C,eAAe,GAAG,qCAAqC;EACvD,gBAAgB,GAAG,sCAAsC;AAC3D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yDAAyD;EACzD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,YAAY,GAAG,4CAA4C;EAC3D,SAAS;EACT,2BAA2B;EAC3B,8BAA8B,GAAG,qCAAqC;AACxE;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,SAAS;AACX;;AAEA;EACE;IACE,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;AACA;;GAEG","sourcesContent":["#deck {\n  overscroll-behavior-y: contain;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n  user-select: none;\n  position: fixed;\n  overflow: hidden;\n  background-color: var(--background);\n}\n\n#deck > .animated {\n  position: absolute;\n  width: 100vw;\n  height: 65vh;\n  will-change: transform;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 10vh;\n  z-index: 2;\n}\n\n#deck > .animated > .card {\n  box-shadow: var(--theme-consistent) 0px 0px 2px 0px;\n  background-size: auto 85%;\n  background-repeat: no-repeat;\n  background-position: center center;\n  border-radius: 10px;\n}\n\n#deck .loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n#deck .deck-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n#deck .load-button {\n  background: linear-gradient(135deg, #ff5e5e, #ff9966);\n  color: white;\n  border-radius: 8px;\n  padding: 12px 24px;\n  box-shadow: rgba(40, 40, 40, 0.35) 0px 5px 15px;\n  border: none;\n  cursor: pointer;\n  font-size: 1.125rem;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  width: 100%;\n  max-width: 400px;\n}\n\n#deck .subscription-pitch-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#deck .expand-search {\n  width: 90vw;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  color: var(--text-primary);\n}\n\n#deck .load-button:active {\n  transform: scale(0.95);\n  box-shadow: 0px 3px 10px rgba(255, 153, 102, 0.3);\n}\n\n#deck .undo-button,\n#deck .fetchDetail-button {\n  position: absolute;\n  top: 17%;\n  background: linear-gradient(135deg, #ff5e5e, #ff9966);\n  border: none;\n  color: white;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  padding: 0 8px;\n  border-radius: 4px;\n  font-size: 2.25em;\n  transition-duration: 0.4s;\n  cursor: pointer;\n  z-index: 2;\n  box-shadow: 0px 5px 20px rgba(255, 153, 102, 0.5);\n  width: auto;  /* Override any inherited width */\n  max-width: none;  /* Override any inherited max-width */\n  min-height: auto;  /* Override any inherited min-height */\n}\n\n#deck .undo-button {\n  left: 21vw;\n}\n\n#deck .fetchDetail-button {\n  right: 21vw;\n}\n\n#deck .undo-button:disabled {\n  color: #aaa;\n  background: linear-gradient(135deg, #ff5e5e5f, #ff996647);\n  cursor: not-allowed;\n}\n\n#deck .modalSpinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  width: 100%;\n  z-index: 2;\n}\n\n#deck .fetchingContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n#deck .isFetchingText {\n  color: var(--theme-consistent);\n  font-size: 1.5rem;\n}\n\n#deck .button-container {\n  width: 90vw;\n  height: calc(100vh - 150px);\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  align-items: center;\n  flex-direction: column;\n  overflow-y: auto;\n  padding: 16px;\n  margin-bottom: 4rem;\n}\n\n/* Make all direct children follow flex rules */\n#deck .button-container > * {\n  width: 100%;\n  max-width: 400px;\n  margin: 0;\n}\n\n#deck .undo-button.end-of-deck {\n  position: fixed;\n  top: auto;\n  bottom: 50px;  /* Or wherever looks good with your layout */\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 999999999999999999999;  /* Ensure it's above other elements */\n}\n\n#deck .expand-search p {\n  margin-bottom: 12px;\n}\n\n/* Style nested p tags in buttons */\n#deck .load-button p {\n  margin: 0;\n}\n\n@media screen and (max-width: 640px) {\n  #deck .button-container {\n    gap: 8px;\n    padding: 12px;\n  }\n\n  #deck .load-button {\n    font-size: 1rem;\n    padding: 10px 20px;\n    min-height: 44px;\n  }\n}\n\n/* For smaller iPhones (iPhone SE, standard iPhone models) */\n@media screen and (max-width: 427px) {\n  #deck .button-container {\n    gap: 8px;\n    padding: 12px;\n  }\n\n  #deck .load-button {\n    font-size: 1rem;\n    padding: 10px 20px;\n    min-height: 44px;\n  }\n}\n\n/* For iPhone Max sizes and tablets up to 640px */\n@media screen and (min-width: 428px) and (max-width: 640px) {\n  #deck .button-container {\n    gap: 8px;\n    padding: 12px;\n  }\n\n  #deck .load-button {\n    font-size: 1.4rem;\n    padding: 20px 40px;\n    min-height: 44px;\n  }\n}\n/* .hide {\n  display: none;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
